import React from 'react';

import { CompaniesDataContext } from '../../contexts/companies-data-context/companies-data-context';

export const useCompanyData = () => {
  const context = React.useContext(CompaniesDataContext);

  if (!context) {
    throw new Error('You must provice CompaniesDataContext.Provider');
  }

  return context;
};
